module.exports = __webpack_public_path__ + "static/media/Practical-stress-logo.fce6d4d4.svg";